import React from 'react';
import { Row, Col, Container, Nav, Dropdown, Carousel } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

export default (cardCarouselItems) => {
    const { content } = cardCarouselItems;
    const { l } = useOutletContext();

    const [index, setIndex] = useState(0);
    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (

        <Row className='mx-auto'>
            <Carousel className='mt-2' activeIndex={index} onSelect={handleSelect} indicators={false}>
                {content.map(({ card }, idx) => (
                    <Carousel.Item key={idx}>
                        <img
                            src={card.imgSrc.file}
                            style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                objectPosition: "left center",
                                borderRadius: "10px"
                            }}
                            alt={`slide-${idx}`}
                        />
                        <Row className='m-0 p-0 justify-content-center' style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", color: "white", textShadow: "2px 2px 4px #000000" }}>
                            <Col className='p-4' xl={6} lg={8} md={10} sm={12}>
                                <h2 className='text-center mt-5' style={{ fontSiz: "2rem" }}>{l(card.titleSwe, card.titleEng)}</h2>
                                <p className='text-center mt-5' style={{ fontSize: "1.2rem" }}>{l(card.contentSwe, card.contentEng)}</p>
                            </Col>
                        </Row>
                    </Carousel.Item>
                ))}
            </Carousel>
        </Row>
    );
}